import React, { Component } from 'react';
import PropTypes, { oneOfType } from 'prop-types';
import NumberFormatter from './NumberFormatter';
import RFField from '../components/Form/RFField';

class SlaveAvInput extends Component {
  constructor(props) {
    super(props);
    this.style = { textAlign: 'right' };
  }

  format = (valueOriginal) => {
    if (!valueOriginal)
      return "";

    // Töröl minden olyan karaktert, ami nem a tartozik mennyiséghez, összeghez vagy adó/bankszámla/taj... számhoz
    let value = valueOriginal.replace(/[^\d\.\-]/g, "");

    if (this.props.format)
      value = this.props.format(value);

    switch (this.props.szuroTipus) {
      case NumberFormatter.ADOSZAM:
        return NumberFormatter.addHyphensToString(value);

      case NumberFormatter.SZAM:
        return NumberFormatter.removeSpacesFromString(value);

      case NumberFormatter.BANKSZAMLA:
        return NumberFormatter.addHyphensToStringBankszamla(value);

      default:
        return NumberFormatter.addSpacesToString(value, this.props.szuroTipus, this.props.emptyStringOnZero);
    }
  }

  // Az a funkció, ami visszafordítja a format által végrehajtott formázást
  // Normál esetben a format formázna és a parse-ban nem lenne semmi extra (így a mutatott érték meg lenne formázva, de az eltárolt nem),
  // de az RFField-ben megvalósított target.value használat miatt ez a legegyszerűbb megoldás ami nem igényel teljes átírást
  reverseFormatting = (value) => {
    if (!value)
      return "";

    // Meg van formázva a format-ban használt módon azért, hogy a karakterszám túllépést lekezelje, például adószám esetén az 12345678-9-012 hibás bemenetből a 2-t levágja
    switch (this.props.szuroTipus) {
      case NumberFormatter.ADOSZAM:
        value = NumberFormatter.addHyphensToString(value);
        break;
      case NumberFormatter.BANKSZAMLA:
        value = NumberFormatter.addHyphensToStringBankszamla(value);
        break;
    }

    if (this.props.parse)
      value = this.props.parse(value);

    value =  value.replace(/[^\d\.\-]/g, "");
    value = NumberFormatter.removeSpacesFromString(value);
    value = NumberFormatter.removeHyphensFromString(value);

    return value;
  }

  render() {
    return (
      <div key={this.props.key}>
        <RFField
          label={!this.props.hideLabel && this.props.label}
          style={this.style}
          className={this.props.className}
          name={this.props.name}
          id={this.props.id}
          format={this.format}
          parse={this.reverseFormatting}
          type={this.props.type}
          // initialValue={this.props.value}
          value={this.props.value}
          maxLength={this.props.maxLength}
          required={this.props.required}
          disabled={this.props.disabled}
          tooltip={this.props.tooltip}
          // onBlur={this.props.onChange}
          onChange={this.props.onChange}
          pattern={this.props.pattern}
          ref={this.props.ref}
          validate={this.props.validate}
          prepend={this.props.prepend}
          append={this.props.append || this.props.inputGroupAddon}
          forcedValue={this.props.forcedValue}
        />
      </div>
    );
  }
}

SlaveAvInput.propTypes = {
  value: PropTypes.object,
  label: PropTypes.string,
  id: PropTypes.string,
  key: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.string,
  szuroTipus: PropTypes.object,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  max: PropTypes.string,
  min: PropTypes.string,
  onChange: PropTypes.func,
  inputGroupAddon: PropTypes.string,
  pattern: PropTypes.string,
  ref: PropTypes.string,
  emptyStringOnZero: PropTypes.bool,
  validate: PropTypes.object,
  hideLabel: PropTypes.bool,
  format: PropTypes.func,
  parent: PropTypes.func,
};

export default SlaveAvInput;
